import { HistoryUpdatesItemType } from 'src/components/History/types';

export const historyUpdates: HistoryUpdatesItemType[] = [
    { key: 'WEBHOOK_TYPE', translateKey: 'webhookDetail.webhookType' },
    { key: 'METHOD', translateKey: 'webhookDetail.method' },
    { key: 'ACTIVE', translateKey: 'webhookDetail.active' },
    { key: 'URL', translateKey: 'webhookDetail.url' },
    { key: 'PARAMETERS', translateKey: 'webhookDetail.parameters' },
    { key: 'PAYLOAD_VERSION', translateKey: 'webhookDetail.payloadVersion' },
    { key: 'REGISTERED_AT', translateKey: 'webhookDetail.registeredAt', format: 'date' },
    { key: 'UNREGISTERED_AT', translateKey: 'webhookDetail.unregisteredAt', format: 'date' },
    { key: 'DEACTIVATION_EMAIL_SENT_AT', translateKey: 'webhookDetail.deactivationEmailSentAt', format: 'date' },
    { key: 'SECRET_REGENERATED', translateKey: 'webhookDetail.secretRegenerated' },
];

export type EditKeysType =
    | 'WEBHOOK_TYPE'
    | 'METHOD'
    | 'ACTIVE'
    | 'URL'
    | 'PARAMETERS'
    | 'PAYLOAD_VERSION'
    | 'REGISTERED_AT'
    | 'UNREGISTERED_AT'
    | 'DEACTIVATION_EMAIL_SENT_AT';

export const EDIT_KEYS: EditKeysType[] = [
    'WEBHOOK_TYPE',
    'METHOD',
    'ACTIVE',
    'URL',
    'PARAMETERS',
    'PAYLOAD_VERSION',
];
